import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import {
    LOGIC_OPERATOR_CONTAINS,
    LOGIC_OPERATOR_NOT_CONTAINS,
    LOGIC_OPERATOR_EQUALS_ANY,
    LOGIC_OPERATOR_NOT_EQUALS_ANY,
    VALUE_TYPE_QUESTION,
    VALUE_TYPE_STRING,
} from 'common/entities/formLogicRule/constants';

import FormLogicOperations from './FormLogicOperations';
import FormLogicValueSet from './FormLogicValueSet';

const shouldAllowMultipleInputs = (operator) =>
    operator === LOGIC_OPERATOR_CONTAINS ||
    operator === LOGIC_OPERATOR_NOT_CONTAINS ||
    operator === LOGIC_OPERATOR_EQUALS_ANY ||
    operator === LOGIC_OPERATOR_NOT_EQUALS_ANY;

export default class FormLogicCondition extends Component {
    static propTypes = {
        operandNodes: PropTypes.array.isRequired,
        id: PropTypes.string.isRequired,
        operandLeft: PropTypes.any.isRequired,
        operator: PropTypes.string.isRequired,
        operandRight: PropTypes.any.isRequired,
        onChangeOperandLeft: PropTypes.func.isRequired,
        onChangeOperator: PropTypes.func.isRequired,
        onChangeOperandRight: PropTypes.func.isRequired,
        removeFormLogicEffect: PropTypes.func.isRequired,
        formNodeWithLogicIsProtected: PropTypes.bool.isRequired,
    };

    handleChangeOperandLeft = (event, value) => {
        this.props.onChangeOperandLeft(this.props.id, value, VALUE_TYPE_QUESTION);
    };

    handleChangeOperandRight = (event, value) => {
        this.props.onChangeOperandRight(this.props.id, value, VALUE_TYPE_STRING);
    };

    handleResetValue = (prevOperator, nextOperator) => {
        const isPrevOperatorContainsOrEqualsAny = shouldAllowMultipleInputs(prevOperator);
        const isNextOperatorContainsOrEqualsAny = shouldAllowMultipleInputs(nextOperator);
        if (isPrevOperatorContainsOrEqualsAny !== isNextOperatorContainsOrEqualsAny) {
            this.handleChangeOperandRight(null, '');
        }
    };

    handleChangeOperator = (event, value) => {
        this.handleResetValue(this.props.operator, value);
        this.props.onChangeOperator(this.props.id, value);
    };

    handleClickRemoveCondition = (event) => {
        // @TODO: If we're allowing the default value to be set and this is the last one, don't
        // actually remove it, just null out the operands and operator
        this.props.removeFormLogicEffect({ logicRuleIds: [this.props.id] });
    };

    render() {
        const { operandNodes, operandLeft, operandRight, operator, formNodeWithLogicIsProtected } = this.props;

        const allowMultipleInput = shouldAllowMultipleInputs(operator);
        const operandNode = operandNodes.find((node) => node.id === operandLeft);
        const logicOperandNode = operandNodes.find((node) => node.id === operandLeft);
        const operandOptions = get(logicOperandNode, 'config.options.entities', {});

        return (
            <FormLogicValueSet
                allowMultipleInput={allowMultipleInput}
                operandRight={operandRight}
                operandOptions={operandOptions}
                handleChangeOperandRight={this.handleChangeOperandRight}
            >
                <FormLogicOperations
                    operandNodes={operandNodes}
                    operandNode={operandNode}
                    operandLeft={operandLeft}
                    operator={operator}
                    handleChangeOperandLeft={this.handleChangeOperandLeft}
                    handleChangeOperator={this.handleChangeOperator}
                    handleClickRemoveCondition={this.handleClickRemoveCondition}
                    formNodeWithLogicIsProtected={formNodeWithLogicIsProtected}
                />
            </FormLogicValueSet>
        );
    }
}
